"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRADIENT = exports.GREY_HUE = exports.UTILITY = exports.THEME = exports.GREY = exports.PURPLE = exports.YELLOW = exports.ORANGE = exports.GREEN = exports.RED = exports.BLUE = exports.calcGrey = exports.calcGradient = void 0;
var tslib_1 = require("tslib");
var design_tokens_1 = require("@hopin-team/design-tokens");
var calc_gradient_1 = require("./calc-gradient");
Object.defineProperty(exports, "calcGradient", { enumerable: true, get: function () { return calc_gradient_1.calcGradient; } });
var calc_grey_1 = require("./calc-grey");
Object.defineProperty(exports, "calcGrey", { enumerable: true, get: function () { return calc_grey_1.calcGrey; } });
function generateColorScheme(colorSet, DEFAULT) {
    return colorSet.reduce(function (result, _a) {
        var _b = tslib_1.__read(_a, 2), key = _b[0], val = _b[1];
        var legacyKey = key.replace(/^\w+_(\d+)$/, "$1");
        if (legacyKey !== '0') {
            legacyKey += '0';
        }
        result[legacyKey] = "".concat(val);
        result[key] = "".concat(val);
        return result;
    }, { DEFAULT: "".concat(DEFAULT) });
}
function filterSets(tokenSet, groups) {
    return groups.map(function (group) { return tokenSet.filter(function (_a) {
        var _b = tslib_1.__read(_a, 1), key = _b[0];
        return key.startsWith(group);
    }); });
}
var sysPrefix = 'PdsColorSys';
var refPrefix = 'PdsColorRef';
var sys = Object.entries(design_tokens_1.hopin).filter(function (_a) {
    var _b = tslib_1.__read(_a, 1), key = _b[0];
    return key.startsWith(sysPrefix);
});
var ref = Object.entries(design_tokens_1.hopin).filter(function (_a) {
    var _b = tslib_1.__read(_a, 1), key = _b[0];
    return key.startsWith(refPrefix);
});
var _b = tslib_1.__read(filterSets(sys, ['Blue', 'Red', 'Green', 'Orange', 'Yellow', 'Purple'].map(function (color) { return "".concat(sysPrefix).concat(color); })), 6), blues = _b[0], reds = _b[1], greens = _b[2], oranges = _b[3], yellows = _b[4], purples = _b[5];
var defaultColors = [
    "".concat(blues[4][1]),
    "".concat(reds[4][1]),
    "".concat(greens[4][1]),
    "".concat(oranges[4][1]),
    "".concat(yellows[3][1]),
    "".concat(purples[4][1]),
];
var greys = ref.filter(function (_a) {
    var _b = tslib_1.__read(_a, 1), key = _b[0];
    return key.startsWith("".concat(refPrefix, "Neutral"));
});
exports.BLUE = (_a = tslib_1.__read([
    blues,
    reds,
    greens,
    oranges,
    yellows,
    purples,
].map(function (colorTokenSet, index) {
    return generateColorScheme(colorTokenSet, defaultColors[index]);
}), 6), _a[0]), exports.RED = _a[1], exports.GREEN = _a[2], exports.ORANGE = _a[3], exports.YELLOW = _a[4], exports.PURPLE = _a[5];
exports.GREY = tslib_1.__assign(tslib_1.__assign({}, generateColorScheme(greys, "".concat(greys[9][1]))), { BLACK: design_tokens_1.hopin.PdsColorRefNeutral_100, DARK: design_tokens_1.hopin.PdsColorRefNeutral_80, MEDIUM: design_tokens_1.hopin.PdsColorRefNeutral_60, LIGHT: design_tokens_1.hopin.PdsColorRefNeutral_30, WHITE: design_tokens_1.hopin.PdsColorRefNeutral_0 });
exports.THEME = {
    PRIMARY: design_tokens_1.hopin.PdsColorRefPrimary_50,
    SECONDARY: design_tokens_1.hopin.PdsColorRefPrimary_50,
    TERTIARY: design_tokens_1.hopin.PdsColorRefPrimary_50,
    DEFAULT: design_tokens_1.hopin.PdsColorRefPrimary_50,
};
exports.UTILITY = {
    WARN: design_tokens_1.hopin.PdsColorRefUiStatusWarning_1,
    ACTION: design_tokens_1.hopin.PdsColorRefPrimary_50,
    ERROR: design_tokens_1.hopin.PdsColorRefUiStatusError_1,
    ERROR_INVERSE: design_tokens_1.hopin.PdsColorSysRed_20,
    SUCCESS: design_tokens_1.hopin.PdsColorRefUiStatusSuccess_1,
    DEFAULT: design_tokens_1.hopin.PdsColorRefPrimary_50,
};
exports.GREY_HUE = 226;
exports.GRADIENT = {
    RIGHT: (0, calc_gradient_1.calcGradient)(270, 'rgba(255, 255, 255, 0)', design_tokens_1.hopin.PdsColorRefNeutral_30),
    LEFT: (0, calc_gradient_1.calcGradient)(270, design_tokens_1.hopin.PdsColorRefNeutral_30, 'rgba(255, 255, 255, 0)'),
};
//# sourceMappingURL=index.js.map